import script from "./eurostarSvgIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./eurostarSvgIcon.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__